import { useCallback } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CarAvailabilityLink.module.scss";
import { usePackageCarAvailabilityLink } from "./hook";
import type { VehicleAvailabilityWithSupplier } from "~core-cars/store";
import { useCarsStyles } from "~core-cars/themes";
import { CarsRawEventName, useEmitCoreCarsRawEvent } from "~core-cars/tracking";
import { CoreCarsComponent } from "~core-cars/types";

export type CarAvailabilityLinkType = PlatformComponentProps & {
  car: VehicleAvailabilityWithSupplier;
};

const COMPONENT_KEY = CoreCarsComponent.CarAvailabilityLink;

// Taken from Core, not a fan of the div onClick, may visit later
export const CarAvailabilityLink = (props: CarAvailabilityLinkType) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className, children } = props;
  const { goToPackageShop } = usePackageCarAvailabilityLink(
    props.car.vehicle.id,
    props.car.cancellationPolicy
  );

  const emitEvent = useEmitCoreCarsRawEvent(
    CarsRawEventName.ClickedCarOnAvailability
  );

  const onClick = useCallback(() => {
    emitEvent();
    goToPackageShop();
  }, [emitEvent, goToPackageShop]);

  return (
    <div className={clsx(block, className)}>
      {/* TODO a11y, add aria label, handles keyboard */}
      <Button
        className={cn("button")}
        buttonType={ButtonTypeEnum.Wrap}
        onClick={onClick}
      ></Button>

      {/* handles mouse */}
      <div onClick={onClick} className={cn("card")} tabIndex={-1}>
        {children}
      </div>
    </div>
  );
};
